import script from "./CreatePostgra.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreatePostgra.vue?vue&type=script&lang=ts&setup=true"

import "./CreatePostgra.vue?vue&type=style&index=0&id=4b3b970a&lang=less&scoped=true"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3b970a"]])

export default __exports__